/* eslint-disable @angular-eslint/prefer-standalone */
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AgFns, BaseService, GridOptionsExt, ISortModel, StatusService } from '@core';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { AccountActivationService } from '../services/account-activation.service';
import { AccountDbQueryService } from '../services/account-db-query.service';
import { AccountDbSaveService } from '../services/account-db-save.service';
import { AccountPurchaseOrder } from '@models';
import { UtilFns } from '@utils';
import { ColDef, GridApi, GridReadyEvent } from '@ag-grid-community/core';

export interface IChildrenPurchaseOrder {
  id: string;
  purchaseOrder: AccountPurchaseOrder;
  debitAmt: number;
  creditAmt: number;
  adjustedAmt: number;
}

export interface AllocateParams {
  parentPurchaseOrder: AccountPurchaseOrder;
}

@Component({
  selector: 'prox-purchase-order-allocate.dialog',
  standalone: false,
  templateUrl: './purchase-order-allocate.dialog.component.html',
  styles: [
    `
      .rag-red {
        background-color: #cc222244;
      }
      .rag-green {
        background-color: #33cc3344;
      }
      .rag-blue {
        background-color: #2244cc44;
      }
    `,
  ],
})
export class PurchaseOrderAllocateDialogComponent implements OnInit {
  parentPurchaseOrderId!: string;
  parentPurchaseOrder!: AccountPurchaseOrder;
  childrenPurchaseOrders: AccountPurchaseOrder[] = [];
  allocationDetail: IChildrenPurchaseOrder[] = [];
  p!: AllocateParams;

  gridOptions: GridOptionsExt = {};
  gridApi: GridApi | undefined;

  isPageReady = false;

  constructor(
    private baseService: BaseService,
    private route: ActivatedRoute,
    public dbSaveService: AccountDbSaveService,
    public dbQueryService: AccountDbQueryService,
    public pngDialogService: DialogService,
    public activationService: AccountActivationService,
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig<AllocateParams>,
    private statusService: StatusService,
  ) {}

  async ngOnInit() {
    // this.p = <AllocateParams>this.config.data;
    // if (!this.p.parentPurchaseOrder) {
    //   return;
    // }
    this.parentPurchaseOrderId = '9487c71a-cb72-c0e0-3d64-36769ebc9ac9';

    UtilFns.assertNonEmptyString(this.parentPurchaseOrderId, 'parentPurchaseOrderId');
    this.parentPurchaseOrder = await this.dbQueryService.getAccountPurchaseOrderById(this.parentPurchaseOrderId);
    this.childrenPurchaseOrders = await this.dbQueryService.getAccountChildrenPurchaseOrdersByParentId(
      this.parentPurchaseOrder.accountId,
      this.parentPurchaseOrderId,
    );

    this.childrenPurchaseOrders.forEach((p) => {
      const h = p.parentAccountPurchaseOrderId;
      const i = this.parentPurchaseOrderId;

      if (p.parentAccountPurchaseOrderId === this.parentPurchaseOrderId && !p.isParent()) {
        this.allocationDetail.push({
          id: p.id,
          purchaseOrder: p,
          debitAmt: 0,
          creditAmt: 0,
          adjustedAmt: 0,
        });
      }
    });

    this.gridOptions = AgFns.initGridOptions(this, {
      onGridReady: this.onGridReady,
    });

    this.gridOptions.apiX?.refreshCells();

    this.isPageReady = true;
  }

  public static async open(dialogService: DialogService, data?: any, config?: DynamicDialogConfig<AllocateParams>) {
    // data = { { width: '90vw' }, ...data }
    const ref = dialogService.open(PurchaseOrderAllocateDialogComponent, {
      closable: false,
      draggable: true,
      width: '60vw',
      height: '80vh',
      // baseZIndex: 10000,
      focusOnShow: false,
      ...config,
      data: data,
    });
  }

  onGridReady(event: GridReadyEvent) {
    const gridOptions = event.context.gridOptions;
    const [colDefs, sortModel] = this.getColDefsAndSortModel();

    AgFns.initGrid(event, colDefs, sortModel);
  }
  getColDefsAndSortModel() {
    const colDefs: ColDef[] = [
      { headerName: 'Purchase Order', field: 'purchaseOrder.purchaseOrder', maxWidth: 300, filter: 'agTextColumnFilter' },
      { headerName: 'Start Date', field: 'purchaseOrder.startDate' },
      { headerName: 'End Date', field: 'purchaseOrder.endDate' },
      { headerName: 'Current Balance', field: 'purchaseOrder.amt' },
      {
        headerName: 'Adjusted Balance',
        field: 'adjusted',
        valueGetter: (params) => {
          return UtilFns.fmtCurrency(params.data.purchaseOrder.amt - params.data.creditAmt + params.data.debitAmt);
        },
        cellStyle: (params) => {
          if (params.data.creditAmt !== params.data.debitAmt) {
            return { color: 'red' };
          }
          return { color: 'black' };
        },
      },
      { headerName: 'Debit (+)', field: 'debitAmt', maxWidth: 200, editable: true },
      { headerName: 'Credit (-)', field: 'creditAmt', maxWidth: 200, editable: true },
    ];
    const sortModel: ISortModel = [{ colId: 'purchaseOrder.purchaseOrder', sort: 'asc' }];
    return [colDefs, sortModel] as const;
  }

  sumCredited() {
    let sum = 0;
    this.allocationDetail.forEach((p) => (sum += p.creditAmt));
    return sum;
  }

  sumDebited() {
    let sum = 0;
    this.allocationDetail.forEach((p) => (sum += p.debitAmt));
    return sum;
  }
  adjustedAmt() {
    return this.parentPurchaseOrder.amt - this.sumDebited() + this.sumCredited();
  }

  onOk() {
    this.ref.close();
  }

  onCancel() {
    this.ref.close();
  }
}
